<template>
  <div class="mr-2" v-if="projectFiles">
    <v-toolbar v-if="!taskFiles" flat dark class="secondary">
      <v-icon>file_copy</v-icon>
      <v-toolbar-title>Project Files</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="canEdit" @click="showUploader = !showUploader" color="cyan">{{ showUploader ? 'Close Uploader' : 'Upload Files' }}</v-btn>
    </v-toolbar>
    <!-- File Uploader -->
      <uploader v-if="showUploader" @closeUploader="showUploader = false" @filesUploaded="getUploadFiles" :uploadPath="'projects/' + this.project.id + '/vault/'"  />
    <!-- End: File Uploader -->
    <v-data-table item-key="name+extension" :headers="headers" :items="projectFiles" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td style="cursor:pointer" @click="downloadFile(props.item)"><span class="title">{{ props.item.name }} </span><span v-if="props.item.taskName && !taskFiles" class="font-weight-bold red--text">[{{ props.item.taskName }}]</span></td>
        <td class="justify-center layout px-0">
          <v-icon large :color="fileIcon(props.item).color" class="mr-2" @click="downloadFile(props.item)">{{ fileIcon(props.item).icon }}</v-icon>
        </td>
        <td style="cursor:pointer" @click="downloadFile(props.item)"><span class="font-weight-bold">{{ props.item.timestamp.seconds | moment("from") }}</span><br><span>{{ props.item.timestamp.seconds | moment("MMMM Do YYYY") }}</span></td>
        <td style="width:280px">
          <v-btn :disabled="!canEdit" @click="renameFile(props.item)" class="ml-0" small outline color="grey"><v-icon small left>fa-pen-square</v-icon>Rename</v-btn>
          <!-- <v-btn @click="replaceFile(props.item)" class="ml-0" small outline color="cyan"><v-icon small left>fa-file</v-icon>Replace</v-btn> -->
          <v-btn :disabled="!canEdit" @click="deleteFile(props.item)" class="ml-0" small  outline color="red"><v-icon small left>fa-trash</v-icon>Delete</v-btn>
        </td>
      </template>
    </v-data-table>
    <!-- Rename File Dialog -->
    <v-dialog max-width="600px" v-if="renameDialog" v-model="renameDialog" class="white">
      <v-toolbar dark class="cyan">
        <v-icon>fa-pen-square</v-icon>
        <v-toolbar-title>Rename File - {{ nameHelper }}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text class="text-xs-center" v-if="!customName">
          <v-select v-model="nameHelper" :items="$store.getters.fileDropDowns" label="Select File Name" item-value="text"></v-select>
          <v-btn @click="customName = !customName" class="primary" small>Enter Custom Name</v-btn>
        </v-card-text>
        <v-card-text class="text-xs-center" v-if="customName">
          <v-text-field v-model="nameHelper"></v-text-field>
          <v-btn @click="customName = !customName" class="primary" small>Enter Pre-Defined Name</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="saveRenameFile">Save</v-btn>
          <v-btn color="secondary" flat @click.stop="renameDialog = false; customName = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirm Delete Dialog -->
    <v-dialog v-if="deleteFileDialog" v-model="deleteFileDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline red white--text">Delete File: {{ fileHelper.name }}</v-card-title>
        <v-card-text>You are about to delete the file: {{ fileHelper.name }}! This is PERMANENT and cannot be undone. Are you sure you want to delete this file?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="saveDeleteFile">Delete</v-btn>
          <v-btn color="secondary" flat @click.native="deleteFileDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Confirm Delete Dialog -->
  </div>
</template>

<script>
import Uploader from '../../helpers/Uploader'

export default {
  props: ['project', 'taskFiles'],
  data () {
    return {
      showUploader: false,
      fileList: [],
      uploadedFileList: [],
      renameDialog: false,
      nameHelper: null,
      fileHelper: null,
      customName: true,
      replaceFileDialog: null,
      deleteFileDialog: null,
      headers: [
        { text: 'File Name', align: 'left', sortable: true, value: 'name' },
        { text: 'Download', align: 'center', value: 'download', sortable: false },
        { text: 'Upload Date', value: 'upload_date' },
        { text: '', value: 'rename_file', sortable: false }

      ]
    }
  },
  computed: {
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.project.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.projects
    },
    projectFiles () {
      if (this.taskFiles) {
        return this.taskFiles
      } else {
        const tasks = this.$store.getters.projectTasks
        let files = this.$store.getters.projectFiles
        files.forEach((file, index) => {
          if (file.task_id) {
            const taskName = tasks.filter(f => f.id === file.task_id)
            if (!taskName[0]) {
              console.log('Loading Files Returned an Error. Possible Duplicate?', file, index)
            } else {
              files[index].taskName = taskName[0].name
            }
          }
        })
        return files
      }
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    saveDeleteFile () {
      const payload = { project_id: this.project.id, file_id: this.fileHelper.file_id, name: this.fileHelper.name }
      this.$store.dispatch('deleteFile', payload)
      this.deleteFileDialog = false
    },
    saveRenameFile () {
      const payload = { project_id: this.project.id, file_id: this.fileHelper.file_id, new_name: this.nameHelper, old_name: this.fileHelper.name }
      this.$store.dispatch('fileNameUpdate', payload)
      this.customName = false
      this.renameDialog = false
      this.nameHelper = null
      this.fileHelper = null
    },
    replaceFile (item) {
      this.replaceFileDialog = true
      this.fileHelper = Object.assign({}, item)
    },
    deleteFile (item) {
      this.deleteFileDialog = true
      this.fileHelper = Object.assign({}, item)
    },
    renameFile (item) {
      this.renameDialog = true
      this.fileHelper = Object.assign({}, item)
      this.nameHelper = item.name
    },
    downloadFile (item) {
      window.open(item.url)
    },
    fileIcon (item) {
      if (item.type.includes('pdf')) {
        return {icon: 'fa-file-pdf', color: 'red'}
      } else if (item.type.includes('image')) {
        return {icon: 'photo', color: 'orange'}
      } else if (item.type.includes('png')) {
        return {icon: 'photo', color: 'orange'}
      } else if (item.type.includes('jpg')) {
        return {icon: 'photo', color: 'orange'}
      } else if (item.type.includes('xls')) {
        return {icon: 'fa-file-excel', color: 'green'}
      } else if (item.type.includes('doc')) {
        return {icon: 'fa-file-word', color: 'blue'}
      } else {
        return {icon: 'fa-file', color: 'grey'}
      }
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileName = value.ref.name.replace(/\.[^/.]+$/, '')
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({id: this.project.id, name: selectedFileName, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
      })
      const payload = {id: this.project.id, project_name: this.project.name, files: this.uploadedFileList}
      this.$store.dispatch('projectFiles', payload)
    }
  },
  components: {
    Uploader
  }
}
</script>


// WEBPACK FOOTER //
// src/components/projects/ProjectFiles.vue